import React from 'react';
import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';
import ExpansionPanel from '../../../../../../SolvPatternLibrary/AccordionExpansionPanel';

const Root = styled.div.withConfig({ componentId: 'sc-twrytu-0' })`
  > div > div {
    margin: 1px auto !important;
  }
`;

const TitleContainer = styled.div.withConfig({ componentId: 'sc-twrytu-1' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background-color: ${colors.theWhiteAlbum};
  padding: 10px;
`;

const TitleIcon = styled.img.withConfig({ componentId: 'sc-twrytu-2' })`
  width: 30px;
  margin-right: 10px;
`;

const Title = styled.div.withConfig({ componentId: 'sc-twrytu-3' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  color: ${colors.squid};
  letter-spacing: 0.29px;
  line-height: 24px;
  margin-left: 8px;
`;

const ContentContainer = styled.div.withConfig({ componentId: 'sc-twrytu-4' })`
  width: 90%;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.squid};
  letter-spacing: 0.29px;
  line-height: 24px;
  margin: 0 auto 20px;
`;

const getExpansionPanels = () => {
  return [
    {
      id: 'whats-covered',

      expandIcon: <ExpandMoreIcon htmlColor={colors.squid} />,
      title: (
        <TitleContainer>
          <TitleIcon src="/images/insurance/faq_covered.svg" />

          <Title>What services are covered by my urgent care benefit?</Title>
        </TitleContainer>
      ),
      content: (
        <ContentContainer>
          It covers your visit with a doctor and/or a nurse practitioner. But, if there are
          additional labs, tests, x-rays, or drugs prescribed during the visit, these may not be
          covered and may cost more.
        </ContentContainer>
      ),
    },
    {
      id: 'avoid-costs',

      expandIcon: <ExpandMoreIcon htmlColor={colors.squid} />,
      title: (
        <TitleContainer>
          <TitleIcon src="/images/insurance/faq_hidden.svg" />

          <Title>How can I avoid unexpected costs during my visit?</Title>
        </TitleContainer>
      ),
      content: (
        <ContentContainer>
          <b>Before your visit:</b> Check with the urgent care to see if they are in-network. If the
          urgent care is part of a hospital system, double check to see if they charge additional
          facility fees.
          <br />
          <br />
          <b>During your visit:</b> Ask your doctor or nurse practitioner if they're in your
          insurance plan's "provider network." This helps avoid extra costs for contracted doctors
          that might be out-of-network for you.
          <br />
          <br />
          <b>After your visit:</b> If your doctor recommended any tests (blood work, MRI, etc.), be
          sure to ask to use in-network labs and facilities. After you receive your explanation of
          benefits (EOB), look out for any billing errors; they’re alarmingly common.
        </ContentContainer>
      ),
    },
    {
      id: 'bill',

      expandIcon: <ExpandMoreIcon htmlColor={colors.squid} />,
      title: (
        <TitleContainer>
          <TitleIcon src="/images/insurance/faq_bill.svg" />

          <Title>Will I get a bill after my visit?</Title>
        </TitleContainer>
      ),
      content: (
        <ContentContainer>
          Your insurance company will send you an explanation of benefits (EOB) which explains the
          charges from your visit and what you're responsible for paying. No payment is required at
          this time.
          <br />
          <br />
          The urgent care will then send you a bill if you have a remaining balance due.
        </ContentContainer>
      ),
    },
  ];
};

const CopayFaqExpansionPanel = () => {
  return (
    <Root>
      <ExpansionPanel panels={getExpansionPanels()} />
    </Root>
  );
};

export default CopayFaqExpansionPanel;
